import { subPurposesChanged } from "../../actions/filters";
import makeGroupedMultiSelect from "../../../../shared/make_grouped_multi_select";

const valuesSelector = (state) => state.filters.subPurposes.selectedValues;
const optionsSelector = (state) => state.filters.subPurposes.options;

export default makeGroupedMultiSelect(subPurposesChanged, "Sub-applications", valuesSelector, optionsSelector, { clearable: true, placeholder: "Filter by sub-application" }, { "col-md-3": true });
